import React, { useState, forwardRef } from 'react';

import PropTypes from 'prop-types';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import {Link as RouterLink} from "react-router-dom";
import LaunchTwoToneIcon from '@mui/icons-material/LaunchTwoTone';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import numeral from "numeral";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import {
  Avatar,
  Box,
  Card,
  Grid,
  Slide,
  Tooltip,
  IconButton,
  InputAdornment,
  AvatarGroup,
  Table,
  FormControl,
  InputLabel,
  Select,
  TableBody,
  MenuItem,
  TableCell,
  TableHead,
  Autocomplete,
  TablePagination,
  TableContainer,
  TableRow,
  TextField,
  useTheme,
  useMediaQuery,
  Typography,
} from '@mui/material';
import {Button, Dialog, Zoom} from "@mui/material/index";

import { useSnackbar } from 'notistack';
import moment from "moment/moment";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


function EnhancedTableHead(props) {
  const {  order, orderBy, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {props.filters.status === 'Завршен' && <TableCell >{'Клаузули'}</TableCell>}
        <TableCell >{'Клиенти'}</TableCell>
        <TableCell >{'Спротивни странки'}</TableCell>
        <TableCell
          key={'broj_predmet'}
          align={'center'}
          padding={'none'}
          sortDirection={orderBy === 'broj_predmet' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'broj_predmet'}
            direction={orderBy === 'broj_predmet' ? order : 'asc'}
            onClick={createSortHandler('broj_predmet')}
          >
            {'Број на предмет'}
            {orderBy === 'broj_predmet' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>

        </TableCell>
        <TableCell>{'Вработени'}</TableCell>
        <TableCell
          key={'opis'}
          align={'center'}
          padding={'none'}
          sortDirection={orderBy === 'opis' ? order : false}

        >
          <TableSortLabel
            active={orderBy === 'opis'}
            direction={orderBy === 'opis' ? order : 'asc'}
            onClick={createSortHandler('opis')}
          >
            {'Опис'}
            {orderBy === 'opis' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>

        </TableCell>
        <TableCell
          key={'start_date'}
          align={'center'}
          padding={'none'}
          sortDirection={orderBy === 'osnov' ? order : false}


        >
          <TableSortLabel
            active={orderBy === 'start_date'}
            direction={orderBy === 'start_date' ? order : 'asc'}
            onClick={createSortHandler('start_date')}
          >
            {'Почеток'}
            {orderBy === 'start_date' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>

        </TableCell>
        <TableCell
          key={'kraen_rok'}
          align={'center'}
          padding={'none'}
          sortDirection={orderBy === 'kraen_rok' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'kraen_rok'}
            direction={orderBy === 'kraen_rok' ? order : 'asc'}
            onClick={createSortHandler('kraen_rok')}
          >
            {'Краен рок'}
            {orderBy === 'kraen_rok' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>
        </TableCell>
        <TableCell
          key={'status_obvrska'}
          align={'center'}
          padding={'none'}
          sortDirection={orderBy === 'status_obvrska' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'status_obvrska'}
            direction={orderBy === 'status_obvrska' ? order : 'asc'}
            onClick={createSortHandler('status_obvrska')}
          >
            {'Статус'}
            {orderBy === 'status_obvrska' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>

        </TableCell>
        <TableCell align="center">{'Actions'}</TableCell>

      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const applyFilters = (projects, query, filters) => {
  return projects.filter((project) => {
    let matches = true;

    if (query) {
      const properties = ['opis', 'system_number_obvrska', 'broj_predmet','status_obvrska','zavrsena_obvrska','trosok'];
      let containsQuery = false;

      properties.forEach((property) => {
        if (project[property] && project[property].toString().toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      });
      project.members && project.members && project.members.forEach((member) => {
        if (member.first_name && member.first_name.toString().toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      })
      project.clients && project.clients && project.clients.forEach((member) => {
        if (member.Naziv && member.Naziv.toString().toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      })
      project.contacts && project.contacts && project.contacts.forEach((member) => {
        if (member.naziv_sprotivna_stranka && member.naziv_sprotivna_stranka.toString().toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      })


      if (filters.status_obvrska && project.status_obvrska !== filters.status_obvrska) {
        matches = false;
      }

      if (!containsQuery) {
        matches = false;
      }
    }

    if(filters) {
      Object.keys(filters).forEach((key) => {
        const value = filters[key];

        if(key === 'status_obvrska' && filters.status_obvrska !== null) {
          if (value && project[key] !== value) {
            matches = false;
          }
        }
        if(key === 'client' && filters.client !== null){
          if(!project.clients.find((r) => r.ID === filters.client)){
            matches = false
          }

        }

        // if(value === null && project[key] === 'Реализирана') {
        //   matches = false;
        // }
        //


      });
    }

    return matches;
  });
};
export default function TaboeSortable(props) {
  const theme = useTheme();
  const {enqueueSnackbar} = useSnackbar();
  const { t } = useTranslation();

  const [filters, setFilters] = useState({
    status_obvrska: null,
    client: null,
  });
  const [query, setQuery] = useState('');
  const handleQueryChange = (event) => {
    event.persist();
    setQuery(event.target.value);
  };
  const statusOptions = [
    {
      id: 'all',
      name: 'Сите'
    },
    {
      id: 'Отворена',
      name: 'Отворена'
    },
    {
      id: 'Нереализирана',
      name: 'Нереализирана'
    },
    {
      id: 'Реализирана',
      name: 'Реализирана'
    }
  ];
  const handleClientChange = (client) => {
    if(client && client.hasOwnProperty('ID')){
      setFilters((prevFilters) => ({
        ...prevFilters,
        client: client.ID,
      }));
    }else {
      setFilters((prevFilters) => ({
        ...prevFilters,
        client: null,
      }));
    }

  };
  const handleStatusChange = (e) => {
    let value = null;
    if (e.target.value !== 'all') {
      value = e.target.value;
    }
    setFilters((prevFilters) => ({
      ...prevFilters,
      status_obvrska: value,
    }));
  };
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const minimizeWindow = useMediaQuery(theme.breakpoints.down('lg'));
  const filteredProjects = applyFilters(props.projects, query, filters);

  // const paginatedProjects = applyPagination(filteredProjects, page, limit);
  //
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [deleteID, setDeleteID] = useState(null);

  const handleConfirmDelete = (id) => {
    setOpenConfirmDelete(true);
    setDeleteID(id);
  };

  const closeConfirmDelete = () => {
    setOpenConfirmDelete(false);
    setDeleteID(null);
  };

  const handleDeleteCompleted = () => {
    setOpenConfirmDelete(false);
    window.makeRequest("DEL", `/api/Obvrski?ID=${deleteID}`, null, true, (callback) => {
      props.projects.filter(function(contact) {
        return contact.ID !== deleteID
      });
      props.reload();


    }, (err) => {
      console.log('err', err);
    });

    enqueueSnackbar(t('Обврската е успешно избришана'), {
      variant: 'success',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      TransitionComponent: Zoom
    });
    setDeleteID(null);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - props.projects.length) : 0;

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Card sx={{ p: 1, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} display={'flex'}>
              <Grid item p={1} xs={6}>
                <TextField
                  sx={{ m: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchTwoToneIcon />
                      </InputAdornment>
                    )
                  }}
                  onChange={handleQueryChange}
                  placeholder={'Пребарувај по име на предмет...'}
                  value={query}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item p={1} xs={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  onChange={(e,v) => handleClientChange(v)}
                  options={props.clients}
                  getOptionLabel={option => option.Naziv}
                  renderInput={(params) => <TextField {...params} fullWidth label="Клиенти" />}
                />
              </Grid>
              <Grid item p={1} xs={3}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Статус</InputLabel>
                  <Select
                    value={filters.status_obvrska || 'all'}
                    onChange={handleStatusChange}
                    label={'Прикажи'}
                  >
                    {statusOptions.map((statusOption) => (
                      <MenuItem key={statusOption.id} value={statusOption.id}>
                        {statusOption.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead

              order={order}
              type={props.type}
              filters={filters}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.projects.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {stableSort(filteredProjects, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((project, index) => {
                  let duration = moment.duration(moment().diff(project.kraen_rok));
                  let days = duration.asDays();
                  let color = "";
                  // datum denesen pomal od kraen rok 5 dena
                  if(project.status_obvrska !== 'Реализирана') {
                    // if(days >= -5 && days < 1){
                    color = '#ffe6e6';
                    // }
                  }
                  return (
                    <TableRow
                      style={{backgroundColor: color,}}
                      hover
                      key={project.ID}
                    >
                      <TableCell>
                        <Box display="flex" justifyContent="flex-start">
                          {project.clients.length > 0 && (
                            <AvatarGroup max={4}>
                              {project.clients.map((member) => (
                                <Tooltip
                                  arrow
                                  placement="top"
                                  key={member.ID}
                                  title={member.Naziv}
                                >
                                  {project.clients.length === 1 ?
                                    <Typography
                                      key={member.ID}>{member.Naziv}</Typography>
                                    : <Avatar
                                      {...stringAvatar(member.Naziv)}
                                      sx={{ width: 30, height: 30 }}
                                      key={member.ID}
                                    />}
                                </Tooltip>
                              ))}
                            </AvatarGroup>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" justifyContent="flex-start">
                          {project.contacts.length > 0 && (
                            <AvatarGroup max={4}>
                              {project.contacts.map((member) => (
                                <Tooltip
                                  arrow
                                  placement="top"
                                  key={member.ID}
                                  title={member.naziv_sprotivna_stranka}
                                >
                                  {project.contacts.length === 1 ?
                                    <Typography
                                      key={member.ID}>{member.naziv_sprotivna_stranka}</Typography>
                                    : <Avatar
                                      {...stringAvatar(member.naziv_sprotivna_stranka)}
                                      sx={{ width: 30, height: 30 }}
                                      key={member.ID}
                                    />}
                                </Tooltip>
                              ))}
                            </AvatarGroup>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography noWrap variant="h5">
                          {project.broj_predmet}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" justifyContent="flex-start">
                          {project.members.length > 0 && (
                            <AvatarGroup variant={'circular'} max={4}>
                              {project.members.map((member) => (
                                <Tooltip
                                  arrow
                                  placement="top"
                                  key={member.ID}
                                  title={member.first_name}
                                >
                                  {project.members.length === 1 ?
                                    <Typography
                                      key={member.ID}>{member.first_name}</Typography>
                                    : <Avatar
                                      {...stringAvatar(member.first_name)}
                                      sx={{ width: 30, height: 30 }}
                                      key={member.ID}
                                    />}
                                </Tooltip>
                              ))}
                            </AvatarGroup>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Tooltip  title={MyComponent(project.opis)}>
                          <Typography dangerouslySetInnerHTML={{ __html: project.opis }} noWrap variant="h5">
                          </Typography>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Typography noWrap variant="h5">
                          {moment(project.start_date).format("DD.MM.YYYY  HH:mm")}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography noWrap variant="h5">
                          {moment(project.kraen_rok).format("DD.MM.YYYY  HH:mm")}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography noWrap variant="h5">
                          {project.status_obvrska}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography noWrap>
                          <Tooltip title={t('Преглед')} component={RouterLink}
                                   to={'/obvrska/' + project.ID} arrow>
                            <IconButton color="primary">
                              <LaunchTwoToneIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {project.user_write === true && <Tooltip title={t('Избриши')} arrow>
                            <IconButton
                              onClick={() => handleConfirmDelete(project.ID)}
                              color="primary"
                            >
                              <DeleteTwoToneIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })
              }
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={props.projects.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <DialogWrapper
        open={openConfirmDelete}
        maxWidth="sm"
        fullWidth
        TransitionComponent={Transition}
        keepMounted
        onClose={closeConfirmDelete}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          p={5}
        >
          <AvatarError>
            <CloseIcon />
          </AvatarError>

          <Typography align="center" sx={{ pt: 4, px: 6 }} variant="h1">
            {'Дали сакате да го избришете предметот'}?
          </Typography>

          <Typography
            align="center"
            sx={{ pt: 2, pb: 4, px: 6 }}
            fontWeight="normal"
            color="text.secondary"
            variant="h3"
          >
            {"Нема можност за повторно враќање"}
          </Typography>

          <Box>
            <Button
              variant="text"
              size="large"
              sx={{ mx: 1 }}
              onClick={closeConfirmDelete}
            >
              {'Затвори'}
            </Button>
            <ButtonError
              onClick={handleDeleteCompleted}
              size="large"
              sx={{ mx: 1, px: 3 }}
              variant="contained"
            >
              {'Избриши'}
            </ButtonError>
          </Box>
        </Box>
      </DialogWrapper>
    </Box>
  );
}
const DialogWrapper = styled(Dialog)(
  () => `
      .MuiDialog-paper {
        overflow: visible;
      }
`
);
const AvatarError = styled(Avatar)(
  ({ theme }) => `
      background-color: ${theme.colors.error.lighter};
      color: ${theme.colors.error.main};
      width: ${theme.spacing(12)};
      height: ${theme.spacing(12)};
      .MuiSvgIcon-root {
        font-size: ${theme.typography.pxToRem(45)};
      }
`
);
const ButtonError = styled(Button)(
  ({ theme }) => `
     background: ${theme.colors.error.main};
     color: ${theme.palette.error.contrastText};
     &:hover {
        background: ${theme.colors.error.dark};
     }
    `
);
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function stringAvatar(name) {
  if(name && name.length !== 1) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}`,
    };
  } else {
    return name;
  }

}
function stringToColor(string) {
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}
function MyComponent(e) {
  return <div dangerouslySetInnerHTML={createMarkup(e)} />;
}

function createMarkup(e) {
  return {__html: e};
}
